import { axios } from '@/utils/request'
const api = {
  source: '/order',
  create: '/finance/masterController'
}

// 生成小程序短链
export function generateShortUrl (parameter) {
  return axios({
    url: '/order/order/generateShortUrl',
    method: 'post',
    data: parameter
  })
}

// 获取企业名称和订单来源列表（电信）
export function getDxEnterpriseList (parameter) {
  return axios({
    url: `/enterprise/management/getEnterpriseList`,
    method: 'get',
    params: parameter
  })
}
// 获取CTEI列表
export function getCteiList (parameter) {
  return axios({
    url: `/system/ctei/getCteiList`,
    method: 'get',
    params: parameter
  })
}
// 回收订单列表
export function getBackOrderList (parameter) {
  return axios({
    url: `/order/OrderRecover/faliDispatch`,
    method: 'get',
    params: parameter
  })
}
// 订单列表
export function getOrderList (parameter) {
  return axios({
    url: `/order/merchantOrder/merchantOrderListSearch`,
    method: 'get',
    params: parameter
  })
}
// 电信订单列表
export function getDxOrderList (parameter) {
  return axios({
    url: `/order/merchantOrder/telecomOrderList`,
    method: 'get',
    params: parameter
  })
}
// 订单未完成标记数量
export function noCompleteCount (parameter) {
  return axios({
    url: `/order/merchantOrder/getOrderNumber`,
    method: 'get',
    params: parameter
  })
}
// 旧件返厂
export function updateOrderFactory (parameter) {
  return axios({
    url: `/order/order/updateOrderFactory`,
    method: 'post',
    data: parameter
  })
}
// 物流单号调第三方快递公司
export function expressIdentify (parameter) {
  return axios({
    url: `/order/cloudUtil/expressIdentify`,
    method: 'get',
    params: parameter
  })
}
// 催单
export function cuidan (parameter) {
  return axios({
    url: `/order/reminder/saveReminder`,
    method: 'post',
    data: parameter
  })
}
// 催单列表
export function cuidanList (parameter) {
  return axios({
    url: `/order/reminder/reminderOrderList`,
    method: 'get',
    params: parameter
  })
}

// 催单反馈
export function cuidanResult (parameter) {
  return axios({
    url: `/order/reminder/getFeebackInfo`,
    method: 'get',
    params: parameter
  })
}
// 催单处理
export function cuidanFeedback (parameter) {
  return axios({
    url: `/order/reminder/saveFeeback`,
    method: 'post',
    data: parameter
  })
}
// 米枷锁取消订单获取验证码
export function getCancelCode (parameter) {
  return axios({
    url: `/order/orderProcess/cancelCode`,
    method: 'post',
    data: parameter
  })
}
// 米枷锁取消订单
export function submitCancel (parameter) {
  return axios({
    url: `/order/orderProcess/cancelOrder`,
    method: 'post',
    data: parameter
  })
}
// 根据省市区查查询是否有师傅
export function countMasterForEnterprise (parameter) {
  return axios({
    url: `/order/DispatchOrder/countMasterForEnterprise`,
    method: 'get',
    params: parameter
  })
}
// 师傅查询
export function countMasterForEnterpriseMerchants (parameter) {
  return axios({
    url: `/order/DispatchOrder/countMasterForEnterpriseMerchants`,
    method: 'get',
    params: parameter
  })
}

// 获取查询品牌下拉框数据
export function getList (parameter) {
  return axios({
    url: `/basicdata/orderType/getList/${parameter}`,
    method: 'get'
  })
}

// 首页跳转详情
export function orderLink (parameter) {
  return axios({
    url: '/stuff/link/orderLink',
    method: 'get',
    params: parameter
  })
}

// 师傅联系记录
export function insert2 (parameter) {
  return axios({
    url: '/order/masterPhone/list',
    method: 'get',
    params: parameter
  })
}

export function orderLogList (parameter) {
  return axios({
    url: '/order/log/orderLogList',
    method: 'get',
    params: parameter
  })
}

export function insertHangUpOrder (parameter) {
  return axios({
    url: `/order/hangUp/insertHangUpOrder`,
    method: 'get',
    params: parameter
  })
}

export function hangUpDelete (parameter) {
  return axios({
    url: `/order/hangUp/delete`,
    method: 'get',
    params: parameter
  })
}

export function batchCustomerServiceApply (parameter) {
  return axios({
    url: `/order/orderProcess/batchCustomerServiceApply`,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 删除ctei码（新接口）
export function delCtei (parameter) {
  return axios({
    url: `/system/ctei/delCtei`,
    method: 'post',
    params: parameter
  })
}
export function getListModel (parameter) {
  return axios({
    url: `/basicdata/orderType/getOrderType`,
    method: 'post',
    data: parameter
  })
}
export function getexportList (parameter) {
  return axios({
    url: '/order/order/batchOrderExport',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
// 失败上传处理
export function batchOrderExport (parameter) {
  return axios({
    url: `/order/order/batchOrderExport`,
    method: 'post',
    data: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getisOrderOpened (parameter) {
  return axios({
    url: '/order/order/isOrderOpened',
    method: 'get',
    params: parameter
  })
}

export function getPendingMatterRoleUserList (parameter) {
  return axios({
    url: '/backlog/pendingMatter/getPendingMatterRoleUserList',
    method: 'get',
    params: parameter
  })
}
export function getfinddictAll (parameter) {
  return axios({
    url: '/system/dict/data/findAll',
    method: 'get',
    params: parameter
  })
}
// /api/basicdata/template/infoList/{templateId}
// 获取查询订单类别列表
export function getdeleteOrder (parameter) {
  return axios({
    url: api.source + '/order/deleteOrder',
    method: 'get',
    params: parameter
  })
}
// 获取订单负责人
export function getfindByDeptId (parameter) {
  return axios({
    url: 'system/user/findByDeptId/103',
    method: 'get',
    params: parameter
  })
}
export function getmarketPrincipal (parameter) {
  return axios({
    url: 'system/user/findByDeptId/104',
    method: 'get',
    params: parameter
  })
}

export function getmasterPrincipal (parameter) {
  return axios({
    url: 'system/user/findByDeptId/106',
    method: 'get',
    params: parameter
  })
}
// 获取订单详情
export function getOrderDetail (parameter) {
  return axios({
    url: api.source + '/order/getOrderDetail',
    method: 'get',
    params: parameter
  })
}
// 获取金额信息
export function getOrderMoney (parameter) {
  return axios({
    url: '/order/price/totalPrice',
    method: 'get',
    params: parameter
  })
}
// // 获取关联订单
// export function getOtherOrder(parameter) {
//   return axios({
//     url: '/order/relation/searchOrderRelation',
//     method: 'post',
//     data: parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }
// 获取查询品牌下拉框数据
export function getSelectBrand (parameter) {
  return axios({
    url: '/enterprise/brand/selectBrand',
    method: 'get',
    params: parameter
  })
}
export function getorderInfo (parameter) {
  return axios({
    url: '/order/DispatchOrder/orderInfo',
    method: 'get',
    params: parameter
  })
}

// 获取查询型号下拉框 数据
export function getSelectModel (parameter) {
  return axios({
    url: '/enterprise/model/selectModel',
    method: 'get',
    params: parameter
  })
}
// 获取查询型号下拉框 数据
export function getchangeOrderPrincipal (parameter) {
  return axios({
    url: '/order/DispatchOrder/changeOrderPrincipal',
    method: 'get',
    params: parameter
  })
}
// 省
export function getselectAllProvince (parameter) {
  return axios({
    url: '/basicdata/province/selectAllProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getagainDispatchOrder (parameter) {
  return axios({
    url: '/order/orderProcess/againDispatchOrder',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 市
export function getselectCityName (parameter) {
  return axios({
    url: '/basicdata/city/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 区
export function getselectAreaName (parameter) {
  return axios({
    url: '/basicdata/area/selectAreaName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getSourceList (parameter) {
  return axios({
    url:
      api.source +
      (location.host == 'sx.mtwlockan.com' || location.host == 'lock.jsssyxh.com'
        ? '/lock/orderList'
        : '/order/orderListSearch'),
    method: 'get',
    params: parameter
    // headers: {
    //   'Content-Type': 'application/json;charset=UTF-8'
    // }
  })
}
// 客户自费生成对账单
export function getEnterpriseList (parameter) {
  return axios({
    url: api.create + '/create',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getStayOrder (parameter) {
  return axios({
    url: '/order/order/selectOrderJobRemindList',
    method: 'get',
    params: parameter
  })
}

export function updateOrderJobRemind (parameter) {
  return axios({
    url: '/order/order/updateOrderJobRemind',
    method: 'PUT',
    data: parameter
  })
}

export function addOrderRemindData (parameter) {
  return axios({
    url: '/order/order/addOrderRemindData',
    method: 'post',
    data: parameter
  })
}

export function queryRemind (parameter) {
  return axios({
    url: '/order/order/queryRemind',
    method: 'get',
    params: parameter
  })
}
export const sourceExport = api.source + '/export'

export function getLcOrderToken () {
  return axios({
    url: '/aqara/lc/getLcOrderToken',
    method: 'get'
  })
}

export function pullLcOrderToken (parameter) {
  return axios({
    url: '/aqara/lc/pullLcOrderToken',
    method: 'post',
    data: parameter
  })
}
